'use strict';

import Api from "./Api";

export default class Filiation extends Api {

    static getList(page = 1, perPage = 10) {
        const url = this.url + 'filiation/list';

        return this.getAxios().get(url, {
            params: {
                page: page,
                'per-page': perPage,
            },
        });
    }

    static get(id) {
        const url = this.url + 'filiation/get';

        return this.getAxios().get(url, {
            params: {
                id: id,
            },
        });
    }

    static add(data) {
        const url = this.url + 'filiation/add';

        return this.getAxios().post(url, data);
    }

    static update(data) {
        const url = this.url + 'filiation/update';

        return this.getAxios().post(url, data);
    }

}